import React from 'react'
import PropTypes from 'prop-types'

import { useSelector } from 'react-redux'
import { selectIsLoading } from '@selectors'

import { IconInline, Title } from '@omnilert/components'

import BaseActionButton from '../base-action-button/base-action-button.component'

import useStyles from './contact-button.style'

const ContactButton = (props) => {
  const { documentId, data } = props

  const { contactData, contactType, icon, id, title } = data

  const loading = useSelector(selectIsLoading)

  const isLoading = loading.some(({ meta }) => id === meta?.actionId)

  const isMaxPillLength = title.length > 30

  const classes = useStyles({ isLoading, isMaxPillLength })

  const handleClick = () => {
    const phoneNumber = contactData.replace('+', '')

    switch (contactType) {
    case 'SMS':
      window.location.href = `sms:${phoneNumber}?&body=`
      break
    case 'Email':
      window.location.href = `mailto:${contactData}`
      break
    case 'Voice':
      window.location.href = `tel:${phoneNumber}`
      break
    default:
      break
    }
  }

  const iconName = () => {
    if (isLoading) return 'spinner'
    return icon
  }

  return (
    <BaseActionButton
      key={`carouselItem-${id}`}
      className={classes.button}
      data={data}
      documentId={documentId}
      onClick={handleClick}
      pill
    >
      <IconInline
        className={classes.icon}
        name={iconName()}
        rotate={0}
        size={20}
      />
      <Title
        className={classes.title}
        color='var(--card--text__color)'
        size='xs'
      >
        {title}
      </Title>
    </BaseActionButton>
  )
}

ContactButton.defaultProps = {
  className: '',
  data: null,
  variant: ''
}

ContactButton.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object.isRequired
}

export default ContactButton
